import { useEffect } from 'react';
import { createBrowserHistory as createHistory } from 'history';
import ReactDOM from "react-dom";
import { Admin, Resource } from 'react-admin';
import simpleRestProvider from 'ra-data-simple-rest';
import apiClient from '~/services/api-client';
import { AuthProvider, getAuthenticationResources, setAuthenticationApiClient, Login } from '@develnet/authentication';
import urls from '~/services/urls';
import i18nProvider from '~/services/i18nProvider';
import customRoutes from '~/components/Routes';
import { QueryClient, QueryClientProvider } from 'react-query';
import FileExplorer from '~/components/file-explorer/FileExplorer';
import FolderIcon from '@material-ui/icons/Folder';
import { fetchUtils } from 'ra-core';
import { TagGroupList } from "./tag-group/TagGroupList";
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import { TagGroupCreate } from "./tag-group/TagGroupCreate";
import { TagGroupEdit } from "./tag-group/TagGroupEdit";
import activeFlags from "../services/flagProvider";
import Cookies from 'js-cookie'

const fetchJson = (url, options = {}) => {
    if (!options.headers) {
        options.headers = new Headers({ Accept: 'application/json' });
    }
    options.headers.set('X-XSRF-TOKEN', Cookies.get('XSRF-TOKEN'));
    return fetchUtils.fetchJson(url, options);
};

const dataProvider = simpleRestProvider(urls.apiBase, fetchJson, 'X-Total-Count');
const history = createHistory();
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: false,
        },
    }
});

const App = () => {
    useEffect(() => {
        setAuthenticationApiClient(apiClient);
    }, []);

    return (
        <QueryClientProvider client={queryClient}>
            <Admin
            dataProvider={dataProvider}
            authProvider={new AuthProvider(apiClient, activeFlags)}
            i18nProvider={i18nProvider}
            customRoutes={customRoutes}
            history={history}
            disableTelemetry
            loginPage={Login}>
                {permissions => {
                    return [
                        <Resource name="file-explorer" list={permissions.has('view-files') ? FileExplorer : null} icon={FolderIcon} options={{label: `cmss.resources.file-explorer.name`}}/>,
                        <Resource name="tag-group" list={permissions.has('manage-tags') ? TagGroupList : null} create={permissions.has('manage-tags') ? TagGroupCreate : null} edit={permissions.has('manage-tags') ? TagGroupEdit : null} icon={LocalOfferIcon} options={{label: `cmss.resources.tag-group.name`}}/>,
                    ]
                    .concat(getAuthenticationResources(permissions));
                }}
            </Admin>
        </QueryClientProvider>
    )
}

export default App;

if (document.getElementById('app')) {
    ReactDOM.render(<App />, document.getElementById('app'));
}
